// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2S_ho","boxTitle":"Qualiphy_boxTitle__2Og-j","box":"Qualiphy_box__1iJQa","toggleWrap":"Qualiphy_toggleWrap__2LJ4a"};